import { useMutation } from '@tanstack/react-query';
import { orpc, useInvalidateRpcQueryFn } from '@/api/rpc/client';

/**
 * Refresh what a split or its undo changes: the invoice (lines, totals,
 * status) and the line match lists, since the affected lines' matches are
 * removed.
 */
function useInvalidateSplitQueries() {
  return useInvalidateRpcQueryFn((orpc) => [
    orpc.accountsPayable.invoices.get.key(),
    orpc.accountsPayable.invoices.list.key(),
    orpc.core.entityAssociations.list.key(),
  ]);
}

/** Split one AP invoice line into several. */
export function useSplitAPInvoiceLineItem() {
  const invalidateQueries = useInvalidateSplitQueries();
  return useMutation(
    orpc.accountsPayable.invoices.splitLineItem.mutationOptions({
      onSuccess: () => {
        invalidateQueries();
      },
    }),
  );
}

/** Put a split AP invoice line back together. */
export function useUndoAPInvoiceLineItemSplit() {
  const invalidateQueries = useInvalidateSplitQueries();
  return useMutation(
    orpc.accountsPayable.invoices.undoLineItemSplit.mutationOptions({
      onSuccess: () => {
        invalidateQueries();
      },
    }),
  );
}
